import ChartElearning from "../../../../src/client/katnh/interactions/elearning/Chart.js";
import ElearningModuleB from "../../../../src/client/katnh/elearning-module-b.json";
import * as React from 'react';
export default {
  ChartElearning,
  ElearningModuleB,
  React
};